import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionButton from '../../ActionButton/ActionButton';
import { usePredictorStore } from '../../../store/predictor/predictorStore';
import { usePlayClickedAction } from '../../../store/entry/entryActions';
import { isAusGame, useConfigStore } from 'store/options/optionsStore';
import NextEventCountdown from '../../NextEventCountdown/NextEventCountdown';
import { useShallow } from 'zustand/react/shallow';

export const PlayState = () => {
  const countryCode = useConfigStore((s) => s.countryCode);
  const gameTitle = useConfigStore((s) => s.gameTitle);
  const setPlayClicked = usePlayClickedAction();
  return (
    <>
      {gameTitle && <div className={'start-screen__game-title'}>{gameTitle}</div>}
      <NextEventCountdown eventStartedCallback={() => {}} />

      <div className='start-screen__play-button'>
        <ActionButton
          onClick={() => {
            setPlayClicked(true);
          }}
          translationKey={isAusGame(countryCode) ? 'play-here' : 'play-for-free-capitals'}
        />
      </div>
    </>
  );
};

export const NextGameState = () => {
  const { t } = useTranslation();
  const gameTitle = useConfigStore((s) => s.gameTitle);
  const [activePredictor, nextPredictor] = usePredictorStore(useShallow((s) => [s.activePredictor, s.nextPredictor]));
  return (
    <div className={`${activePredictor || nextPredictor ? '' : 'no-game'}`}>
      {(activePredictor || nextPredictor) && (
        <div className='start-screen__game-in-progress'>
          <div className='start-screen__game-in-progress__text'>
            {gameTitle ? t('game-title-in-progress', { gameTitle }) : t('game-in-progress')}
          </div>
        </div>
      )}
      <div className='start-screen__next-game'>
        <NextGameText />
      </div>
    </div>
  );
};

const NextGameText = () => {
  const { t } = useTranslation();
  const gameTitle = useConfigStore((s) => s.gameTitle);
  const [activePredictor, nextPredictor] = usePredictorStore(useShallow((s) => [s.activePredictor, s.nextPredictor]));
  const noGameState = !nextPredictor && !activePredictor;

  if (nextPredictor && nextPredictor.openTime > Date.now())
    return (
      <>
        <div className={'start-screen__availability-text'}>{t('please-check-the-free-games-tab')}</div>
      </>
    );
  return (
    <div className='start-screen__next-game__text'>
      {noGameState && (
        <>
          {gameTitle && <div className='start-screen__next-game__game-title'>{gameTitle}</div>}
          <div className='start-screen__game-in-progress__text'>{t('game-in-progress')}</div>
        </>
      )}
      {t('next-game-available-soon')}
    </div>
  );
};
